<template>
    <div style="width: 100px" v-if="data.datasets[0].data.length > 0">
        <canvas :id="'line-chart'+index" style="height: auto"></canvas>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue';
import Chart from 'chart.js/auto';

const props = defineProps({
  data: Object,
  index: {
    type: String,
    default: ''
  }
});

const chartData = ref({
  type: 'doughnut',
  data: {},
  options: {
    responsive: true,

		layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }
    },
    //maintainAspectRatio: false,
    //aspectRatio: 3,
		scales: {
      yAxes: [{
        ticks: {
          beginAtZero:true
        }
      }]
    },
    plugins: {
      legend: {
        display: false
        //position: 'right',
      },
      tooltip: {
        enabled: false,
      },
      title: {
        display: false
      }
    }
  }
});

let graf = null;

const renderData = () => {
  if (graf !== null) {
    graf.destroy();
  }
  const ctx = document.getElementById('line-chart' + props.index);
  chartData.value.data = props.data;
  graf = new Chart(ctx, chartData.value);
}

onMounted(renderData);

watch(() => props.data, renderData);

</script>

<style scoped>

</style>
